import { apiFuns } from "sw-hic";
let api = {
  FeeStandard: apiFuns.genStandard("feeStandard", "/api/md"),
};
export default api;
